import dedent from 'dedent';
import { z } from 'zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';

export type WebsiteType = z.infer<typeof typeSchema>;

export const typeSchema = z.enum(['website', 'renewal']);

export default createPerformableConfig(
  'website',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      type: typeSchema,
      domain: z.string().optional(),
    }),
  },
  {
    name: 'Single Property Website',
    group: 'Listing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/website/thumbnail_v2.jpg',
    images: [],
    short: dedent`
      Beyond RE Marketing’s Single Property Website integrates all listing media \
      into one shareable link, optimizing exposure on MLS and social media.
    `,
  },
);
